import type { SyntheticEvent } from "react";

// Two recordings playing over each other are unintelligible, so starting one
// pauses every other audio element on the page, wherever it is rendered.
export function pauseOtherAudio(event: SyntheticEvent<HTMLAudioElement>): void {
  for (const audio of document.querySelectorAll("audio")) {
    if (audio !== event.currentTarget && !audio.paused) {
      audio.pause();
    }
  }
}
